import { render, staticRenderFns } from "./AppConfiguration.vue?vue&type=template&id=5cf60812&scoped=true"
import script from "./AppConfiguration.vue?vue&type=script&lang=js"
export * from "./AppConfiguration.vue?vue&type=script&lang=js"
import style0 from "./AppConfiguration.vue?vue&type=style&index=0&id=5cf60812&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf60812",
  null
  
)

export default component.exports